import e from"styled-components";const r=e.div`
	display: flex;
	padding: 4px;
	width: 120px;
	height: 35px;
	margin: 0 auto 20px;
	border-radius: 4px;
	background: ${({theme:e})=>e.bg.primary};
`,t=e.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	flex: 1;
	color: ${({theme:e})=>e.text.text};
	background: ${({theme:e,active:r})=>e.bg[r?"hover":"primary"]};
`,i=e.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px;
	font-size: 12px;
	margin-top: 30px;
	color: ${({theme:e})=>e.text.text};

	span {
		display: flex;
		align-items: center;
		gap: 9px;
	}
`,o=e.div`
	position: relative;
	width: 28px;
	height: 28px;
	border-radius: 4px;
	cursor: pointer;
	border: 1px ${({theme:e})=>e.border.black10} solid;
	background: ${({color:e})=>e};

	&:hover {
		border-color: ${({theme:e})=>e.border.black15};
		filter: brightness(0.94);
	}

	&:after {
		content: '';
		position: absolute;
		border-radius: 6px;
		inset: -4px;

		${({isSelected:e,theme:r})=>{if(e)return`border: 2px solid ${r.border.brand}80;`}}
	}
`,p=e.div`
	.rcp {
		background: ${({theme:e})=>e.bg.general};
	}

	.rcp-saturation {
		border-radius: 4px;
	}

	.rcp-body {
		margin-top: 30px;
		padding: 0;

		.rcp-hue,
		.rcp-alpha {
			margin: 0 20px;
			width: calc(100% - 40px);
		}

		.rcp-fields {
			display: flex;
			align-items: center;
			gap: 6px;
			margin-top: 10px;

			.rcp-fields-element {
				align-items: flex-start;
				gap: 4px;
			}

			& > div:first-child {
				order: 1;
			}

			.rcp-fields-element-label {
				font-weight: 500;
				font-size: 11px;
				line-height: 14px;
				color: ${({theme:e})=>e.text.text};
				order: 0;
				text-transform: none;
			}

			.rcp-fields-element-input {
				background: ${({theme:e})=>e.bg.primary};
				border-radius: 4px;
				border: none;
				padding: 8px 6px;
				font-weight: 400;
				font-size: 11px;
				line-height: 16px;
				color: ${({theme:e})=>e.text.text};
				order: 1;
			}
		}
	}
`;export{o as ColorBox,p as ColorPickerWrapper,i as ColorsContainer,t as Option,r as Switch};
